/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ContentInputs */

const en_share_content = /** @type {(inputs: Share_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Content`)
};

const es_share_content = /** @type {(inputs: Share_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir Contenido`)
};

const fr_share_content = /** @type {(inputs: Share_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager le contenu`)
};

const de_share_content = /** @type {(inputs: Share_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt teilen`)
};

const id_share_content = /** @type {(inputs: Share_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan Konten`)
};

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const ja_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const zh_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const ar_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const it_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const ru_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const pt_share_content = en_share_content;

/** @type {(inputs: Share_ContentInputs) => LocalizedString} */
const ko_share_content = en_share_content;

/**
* | output |
* | --- |
* | "Share Content" |
*
* @param {Share_ContentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_content = /** @type {((inputs?: Share_ContentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ContentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_content(inputs)
	if (locale === "es") return es_share_content(inputs)
	if (locale === "fr") return fr_share_content(inputs)
	if (locale === "de") return de_share_content(inputs)
	if (locale === "ja") return ja_share_content(inputs)
	if (locale === "zh") return zh_share_content(inputs)
	if (locale === "ar") return ar_share_content(inputs)
	if (locale === "id") return id_share_content(inputs)
	if (locale === "it") return it_share_content(inputs)
	if (locale === "ru") return ru_share_content(inputs)
	if (locale === "pt") return pt_share_content(inputs)
	return ko_share_content(inputs)
});